import { FC } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface LoaderProps {
  className?: string;
  height?: number | string;
  width?: number | string;
}

export const Loader: FC<LoaderProps> = (props) => {
  return (
    <SkeletonTheme baseColor="#E2E2E2" highlightColor="#ECECEC" data-testid="skeleton">
      <Skeleton borderRadius={24} {...props} />
    </SkeletonTheme>
  );
};
